/** SVG Aspect Ratio Enum
    @readonly
    @enum {string}
*/
export var SVGASPECTRATIOS;
(function (SVGASPECTRATIOS) {
    SVGASPECTRATIOS["NONE"] = "none";
    SVGASPECTRATIOS["XMIN_YMIN_MEET"] = "xMinYMin meet";
    SVGASPECTRATIOS["XMIN_YMIN_SLICE"] = "xMinYMin slice";
    SVGASPECTRATIOS["XMIN_YMID_MEET"] = "xMinYMid meet";
    SVGASPECTRATIOS["XMIN_YMID_SLICE"] = "xMinYMid slice";
    SVGASPECTRATIOS["XMIN_YMAX_MEET"] = "xMinYMax meet";
    SVGASPECTRATIOS["XMIN_YMAX_SLICE"] = "xMinYMax slice";
    SVGASPECTRATIOS["XMID_YMIN_MEET"] = "xMidYMin meet";
    SVGASPECTRATIOS["XMID_YMIN_SLICE"] = "xMidYMin slice";
    SVGASPECTRATIOS["XMID_YMID_MEET"] = "xMidYMid meet";
    SVGASPECTRATIOS["XMID_YMID_SLICE"] = "xMidYMid slice";
    SVGASPECTRATIOS["XMID_YMAX_MEET"] = "xMidYMax meet";
    SVGASPECTRATIOS["XMID_YMAX_SLICE"] = "xMidYMax slice";
    SVGASPECTRATIOS["XMAX_YMIN_MEET"] = "xMaxYMin meet";
    SVGASPECTRATIOS["XMAX_YMIN_SLICE"] = "xMaxYMin slice";
    SVGASPECTRATIOS["XMAX_YMID_MEET"] = "xMaxYMid meet";
    SVGASPECTRATIOS["XMAX_YMID_SLICE"] = "xMaxYMid slice";
    SVGASPECTRATIOS["XMAX_YMAX_MEET"] = "xMaxYMax meet";
    SVGASPECTRATIOS["XMAX_YMAX_SLICE"] = "xMaxYMax slice";
})(SVGASPECTRATIOS || (SVGASPECTRATIOS = {}));
;
